import { app } from "router/routes"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { actions } from "store"
import { markingWordsHooks } from "../../MarkingWords"

const useSelectAndViewAssessment = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const selectAssessment = async (assessment, route) => {
        dispatch(actions.setAssessment(assessment))
        dispatch(actions.setTestTaker({ test_taker_id: assessment.test_taker_id }))
        navigate(`${route}/${assessment.id}`)
    }
    return selectAssessment
}

const useSelectAndMarking = () => {
    const selectAndViewAssessment = useSelectAndViewAssessment()
    const isTraining = markingWordsHooks.useIsTraining()

    return (assessment) => {
        selectAndViewAssessment(assessment,
            isTraining ?
                app.markingTrainingWordsAssessments : app.markingWordsAssessments)
    }
}

const useSelectAndCutting = () => {
    const selectAndViewAssessment = useSelectAndViewAssessment()

    return (assessment) => {
        selectAndViewAssessment(assessment, app.audioCuttingAssessments)
    }
}

const useSelectAndTranscription = () => {
    const selectAndViewAssessment = useSelectAndViewAssessment()

    return (assessment) => {
        selectAndViewAssessment(assessment, app.transcriptionAssessments)
    }
}


export { useSelectAndTranscription, useSelectAndCutting, useSelectAndMarking }